const rankingItems = [
  { rank: 1, title: '流浪地球3', tag: '热播榜 TOP1', info: '9.3分 · 科幻巨制 · 今日播放量 580万', color: 'bg-accent-500' },
  { rank: 2, title: '哪吒之魔童闹海', tag: '热播榜 TOP2', info: '9.5分 · 国产动画 · 今日播放量 492万', color: 'bg-accent-500' },
  { rank: 3, title: '封神第二部', tag: '热播榜 TOP3', info: '8.9分 · 神话史诗 · 今日播放量 436万', color: 'bg-primary-500' },
  { rank: 4, title: '庆余年3', tag: '剧集榜 TOP1', info: '9.1分 · 古装权谋 · 今日播放量 385万', color: 'bg-primary-500' },
  { rank: 5, title: '大奉打更人', tag: '剧集榜 TOP2', info: '8.7分 · 悬疑探案 · 今日播放量 341万', color: 'bg-secondary-500' },
  { rank: 6, title: '奥本海默', tag: '口碑榜 TOP1', info: '9.4分 · 传记历史 · 今日播放量 298万', color: 'bg-secondary-500' },
  { rank: 7, title: '长安三万里2', tag: '新片榜 TOP1', info: '8.8分 · 动画历史 · 今日播放量 267万', color: 'bg-accent-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            数据榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            实时更新今日播放量最高的热门影视排行
          </p>
        </div>

        <div className="max-w-[720px] mx-auto">
          <div className="rounded-2xl bg-background-50 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 px-5 md:px-6 py-4 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
                } hover:bg-background-100/50 cursor-pointer transition-colors`}
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-lg ${item.color} text-background-50 text-sm font-bold flex-shrink-0`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-400">{item.info}</span>
                  </div>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:block">
                  {item.tag}
                </span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-right-s-line text-foreground-300"></i>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}